export enum OperationCategoryEnum {
    CATEGORY_UNKNOWN = 'CATEGORY_UNKNOWN',
    CATEGORY_OPEN = 'CATEGORY_OPEN',
    CATEGORY_SPECIFIC = 'CATEGORY_SPECIFIC',
    CATEGORY_CERTIFIED = 'CATEGORY_CERTIFIED'
}

export enum OperationCategoryTextEnum {
    CATEGORY_UNKNOWN = 'UNKNOWN',
    CATEGORY_OPEN = 'OPEN',
    CATEGORY_SPECIFIC = 'SPECIFIC',
    CATEGORY_CERTIFIED = 'CERTIFIED'
}